// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { AlertType } from "../../Utils/Alert/AlertType.js";

export let Alert = function (dataCache, paramObj)
{
    this.DataCache = dataCache;

    this.Instrument = paramObj.Instrument;
    this.AlertType = paramObj.AlertType;
    this.Condition = paramObj.Condition;
    this.Value = paramObj.Value;
    this.Importance = paramObj.Importance;
    this.AfterExecute = paramObj.AfterExecute;
    this.Action = paramObj.Action;
    this.Notification = paramObj.Notification;
    this.Expiration = paramObj.Expiration;
    this.MessageText = paramObj.MessageText;

    this.OrderPlaceParametrs = null;

    if (paramObj.OrderPlaceParametrs)
        this.OrderPlaceParametrs = paramObj.OrderPlaceParametrs

    this.Active = paramObj.IsActive;
    this.AlertId = paramObj.AlertId;

    this.leverageValue = paramObj.leverageValue || null
}

Alert.prototype.CanLocateOnChart = function (instrument)
{
    return this.Instrument === instrument && this.Active && this.AlertType !== AlertType.CHANGE && this.AlertType !== AlertType.VOLUME;
}

Alert.prototype.GetDataToSend = function ()
{
    let data = new AlertSendToServerItem();
    data.Instrument = this.Instrument;
    data.AlertType = this.AlertType;
    data.Condition = this.Condition;
    data.Value = this.Value;
    data.Importance = this.Importance;
    data.AfterExecute = this.AfterExecute;
    data.Action = this.Action;
    data.Notification = this.Notification;
    data.Expiration = this.Expiration;
    data.MessageText = this.MessageText;
    if (this.OrderPlaceParametrs)
        data.OrderPlaceParametrs = this.OrderPlaceParametrs.getDataForRequest();
    data.Active = this.Active;
    data.AlertId = this.AlertId;

    if (this.leverageValue)
        data.leverageValue = this.leverageValue

    return data
}

Alert.prototype.dispose = function ()
{
    if (this.OrderPlaceParametrs && this.OrderPlaceParametrs.dispose)
        this.OrderPlaceParametrs.dispose()
}

export let AlertSendToServerItem = function ()
{
    this.Instrument = null;
    this.AlertType = null;
    this.Condition = null;
    this.Value = null;
    this.Importance = null;
    this.AfterExecute = null;
    this.Action = null;
    this.Notification = null;
    this.Expiration = null;
    this.MessageText = null;
    this.OrderPlaceParametrs = null;
    this.Active = null;
    this.AlertId = null;
    this.Account = null;
}